import {get, post} from '@/utils/request'
/* 添加订单 */
export const addOrders = data => post('/orders/addOrders', data)
/* 获取订单列表 */
export const getOrderList = (data) =>
  get(`/sample/detect/findUserOrderDetectAll`, data)
/* 获取订单列表 带预估和核对费用 */
export const getOrderListNew = (data) =>
  get(`/sample/detect/newFindUserOrderDetectAll`, data)
/* 查询订单进度 */
export const findOrderDetect = orderId =>
  get(`/sample/detect/findOrderDetect/${orderId}`)

/* 查询单条订单 */
export const getOneOrder = orderId => get(`/orders/findOrderOne/${orderId}`)

/* 查询单条订单 */
export const newFindOrderOne = orderId => get(`/orders/newFindOrderOne`,{orderId:orderId})
/* 修改订单 */
export const editOrders = data => post('/orders/editOrder', data)
/* 获取订单的修改记录 */
export const getRecordList = (orderId, data) =>
  get(`/orders/findOrderEditRecordList/${orderId}`, data)

/* 获取费用评估 */
export const getCost = orderId =>
  get(`/price/evaluate/findPriceEvaluate/${orderId}`)
/* 确认费用评估 */
export const confirmCost = data =>
  post('/price/evaluate/confirmPriceEvaluate', data)

/* 获取费用核对 */
export const getCostCheck = orderId =>
  get(`/price/check/findPriceCheck/${orderId}`)
/* 确认费用核对 */
export const confirmCostCheck = id =>
  get(`/price/check/confirmPriceCheck/${id}`)

/* 校验是否为会员 */
export const judgeVip = (accountNumber, data) =>
  get(`/orders/verificationMember/${accountNumber}`, data)

export const judgeVips = data => post('/orders/verificationMembers', data)

//免验证校验会员账户
export const passVerification = data => post('/orders/passVerification', data)

/* 获取某个订单的样品编号跟地址详情 */
export const getOrderDetails = orderId =>
  get(`/recovered/samples/findOrderDetails/${orderId}`)

/* 获取订单回收详情 */
export const getOrderRecoveredDetails = orderId =>
  get(`/recovered/samples/findOrderRecoveredDetails/${orderId}`)

/* 获取订单回收详情列表 */
export const findOrderRecoveredDetailsList = orderId =>
  get(`/recovered/samples/findOrderRecoveredDetailsList/${orderId}`)
/* 获取用户所有回收记录 */
export const findUserRecoveredDetailsList = data =>
  post(`/recovered/samples/findUserRecoveredDetailsList`,data)

/* 用户回收样品 */
export const recoveredSamples = data =>
  post(`/recovered/samples/userRecoveredSamples`, data)

/* 获取某个订单进度详情 */
export const getProgressDetails = orderId =>
  get(`/sample/detect/findOrderDetect/${orderId}`)

/* 查询订单进度 */
export const findOrderDetectCloud = (orderId, sampleId) =>
  get(`/sample/detect/findOrderDetectCloud/${orderId}/${sampleId}`)

/* 校验支付方式 */
export const paymentMethod = orderId =>
  get(`/expense/voucher/verifyPaymentMethod/${orderId}`)

/* 获取验证码 */
export const getCode = accountNumber => get(`/orders/sendVar/${accountNumber}`)

/* 获取验证码 */
export const getCode1 = accountNumber =>
  get(`/orders/sendVar1/${accountNumber}`)

/* 子账号申请验证码 */
export const getVipCode = data => get(`/login/getVipCode`,data)

/* 保存付款凭证 */
export const saveExpenseVoucher = data =>
  post(`/expense/voucher/saveExpenseVoucher`, data)

/* 获取付款凭证 */
export const getExpenseVoucher = (orderId, data) =>
  get(`/expense/voucher/findExpenseVoucher/${orderId}`, data)

/* 订单关联会员 */
export const relationVip = data => post(`/orders/affiliatedMember`, data)

/* 校验是否通过付款凭证审核 */
export const getPassesTheAudit = (orderId) =>
  get(`/expense/voucher/findWhetherItPassesTheAudit/${orderId}`)

/* 短信验证消息 */
export const addSmsVerifiy = data => post(`/sms/verifiy/addSmsVerifiy`, data)

/* 获取寄样地址 */
export const getAddress = orderId =>
  get(`/orders/getSampleSendingAddress/${orderId}`)

/* 获取加密后的文件 */
export const getUrl = data => get(`/sample/detect/getUrl`, data)

/* 确认费用核对 */
export const getOrderPriceByOrderId = id =>
  get(`/orders/getOrderPriceByOrderId/${id}`)

/* 获取显示权限 */
export const queryDetectionTypeByTypeShow = data => post(`/dtetect/type/queryDetectionTypeByTypeShow`, data)

/* 新增订单新 */
export const addOrdersNew = data => post(`/orders/addOrdersNew`, data)
/* 修改订单新 */
export const updateOrdersNew = data => post(`/orders/updateOrdersNew`, data)
/* 模版链接使用解析orderDetail */
export const getOrderDetailById = orderId => get(`/orders/getOrderDetailById/${orderId}`)
/* 获取模版id */
export const getOrderTemplateById = data => get(`/userOrderApplication/getOrderTemplateById`, data)
/* 保存委托人信息 */
export const saveClientInfo = data =>get('/orderClientSaveDemo/saveOrderClientInfo',data)
/* 查询客户进度跟进表记录 */
export const findClientOrderProgress = (sampleId) =>get(`/clientOrderProgress/findClientOrderProgress/${sampleId}`)

export const cancelOrder = (orderId) =>get('/orders/cancelOrder',{orderId:orderId})

export const getFolderImg = (orderId) =>get('/folder/list',{ordersId:orderId})

export const getFolderImgsByUserId = () =>get('/folder/listByUser')

export const findUserOrderDetectAllCount = () =>get(`/sample/detect/findUserOrderDetectAllCount`,)

//通过orderId查询一口价
export const getPriceFixedByOrderId = orderId => get(`/price/fixed/getPriceFixedByOrderId/${orderId}`)
/* 保存一口价 */
export const updateOrUpdatePriceFixed = orderId => get(`/price/fixed/updateOrUpdatePriceFixed/${orderId}`)

/* 新增用户反馈 */
export const addClFeedback = (content) => post(`/ClFeedback/add`,content)



// WEBPACK FOOTER //
// ./src/api/order.js